import getUniqueValues from 'src/js/modules/utils/get-unique-values';

const getOptionAttributesByElementId = (option, elementId) => {
  if (option.options) {
    return getUniqueValues(
      option.options.flatMap((subOption) => getOptionAttributesByElementId(subOption, elementId))
    );
  }

  return option.attributes && option.elementIds?.includes(elementId) ? option.attributes : [];
};

export default getOptionAttributesByElementId;
